type EnvKey = 'DEV' | 'STAGING' | 'PRE-PROD' | 'PROD';

interface EnvConfig {
  telegramBotName: string;
  googleClientId: string;
  xClientId: string;
  lineClientId: string;
}

export const AppEnvConfig: Record<EnvKey, EnvConfig> = {
  "DEV": {
    telegramBotName: "tlgm_auth_bot",
    googleClientId: "757849354614-qcb25jnhs1pte88gu9nou5r8nd7c52ug.apps.googleusercontent.com",
    xClientId: 'TV9fUE9pblRDNmVpUXBHbWZIV0E6MTpjaQ',
    lineClientId: "2007230185"
  },

  "STAGING": {
    telegramBotName: "tlgm_auth_bot",
    googleClientId: "757849354614-qcb25jnhs1pte88gu9nou5r8nd7c52ug.apps.googleusercontent.com",
    xClientId: 'TV9fUE9pblRDNmVpUXBHbWZIV0E6MTpjaQ',
    lineClientId: "2007230185"
  },

   "PRE-PROD": {
    telegramBotName: "YoloPreprodTgAuthDesktop_bot",
    googleClientId: "941961551750-jsvar6dltpn2joc3cnr5cumj0kcn666c.apps.googleusercontent.com",
    xClientId: 'MkkwMnY0TEpSQzAwZVlabFQ2WlA6MTpjaQ',
    lineClientId: "2007448729"
  },

  "PROD": {
    telegramBotName: "YoloTgAuthDesktop_bot",
    googleClientId: "941961551750-jsvar6dltpn2joc3cnr5cumj0kcn666c.apps.googleusercontent.com",
    xClientId: 'MkkwMnY0TEpSQzAwZVlabFQ2WlA6MTpjaQ',
    lineClientId: "2007448729"
  },
};
